module.exports = __webpack_public_path__ + "static/media/experience_1.16f1b137.svg";